import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/blocks.action'
import { ISurveyBlockModel } from 'models/block.model'
import { createBlockSurveyInstance } from 'api/administration/blocks/Create'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'

async function handleCreateSurveyBlock(data: ISurveyBlockModel) {
  return await createBlockSurveyInstance(data)
}

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

function* newSurveyBlockEffectSaga(action: any) {
  try {
    const { data } = action
    const result = yield call(handleCreateSurveyBlock, data)
    yield put(fromActions.Actions.createBlockInstanceSuccess(result))
    const {
      block_instance: { lesson_id },
    } = data
    const blocks = yield call(getList, lesson_id)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(blocks))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* createSurveyWatcherSaga() {
  yield takeLatest(fromActions.SURVEY_BLOCK_CREATE, newSurveyBlockEffectSaga)
}
